import React from "react";
import PropTypes from "prop-types";
import { Spinner } from "../Spinner";
import styles from "./LoadingOverlay.scss";

const propTypes = {
  /**
   * If true, shows overlay
   */
  loading: PropTypes.string,
  /**
   * Children that will be overlayed
   */
  children: PropTypes.node,
};

const defaultProps = {
  loading: false,
  children: null,
};

/**
 * When loading, show overlay over wrapped component
 */
function LoadingOverlay(props) {
  const { loading, children } = props;

  return (
    <div className={styles.overlayWrapper}>
      {loading && (
        <>
          <div className={styles.overlay} />
          <div className={styles.spinnerWrapper}>
            <Spinner className={styles.overlaySpinner} />
          </div>
        </>
      )}
      {children}
    </div>
  );
}

LoadingOverlay.propTypes = propTypes;
LoadingOverlay.defaultProps = defaultProps;

export default LoadingOverlay;
